import {Component, OnInit} from '@angular/core';
import {QuotationService} from '../../services/quotation-service/quotation.service';
import {InsureStep} from '../insureStep';
import {Router} from '@angular/router';
import {ParkingSecurity} from '../../model/ParkingSecurity';
import {VehicleUsage} from '../../model/VehicleUsage';
import {ValidationService} from '../../services/validation-service/validation.service';
import {QuotationStep} from '../../model/QuotationStep';
import {LeadService} from '../../services/lead-service/lead.service';
import {ErrorMessages} from '../../model/ErrorMessages';
import {WebLeadType} from '../../model/leads/WebLeadType';
import {Address} from '../../model/Address';
import {BehaviorSubject} from 'rxjs';
import {isNullOrUndefined} from 'util';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {ContentComponent} from '../content/content.component';

@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss']
})
export class StepTwoComponent extends InsureStep implements OnInit {
  public numberPlateRetry: string = null;
  public vinNumberRetry: string = null;
  public vehicleUsage = VehicleUsage;
  public parkingSecurity = ParkingSecurity;
  public showCancelModal = false;
  public vehicleLoading = false;
  public loading = false;
  public leadsFinishedLoading = false;
  public insureFinishedLoading = false;
  public errorMessage = ErrorMessages;
  public searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public addressList: BehaviorSubject<Address[]> = new BehaviorSubject<Address[]>([]);
  public searched = false;
  private getQuoteMessage = '';

  constructor(router: Router,
              public quotationService: QuotationService,
              public validationService: ValidationService,
              private leadService: LeadService,
              private contentComponent: ContentComponent) {
    super(router, quotationService);
    if (this.quotationService.getRetries() === 0) {
      this.quotationService.error = true;
    }
  }

  ngOnInit() {
    this.quotationService.campaign = sessionStorage.getItem('campaign');
    this.searchTerm.pipe(debounceTime(500),
      distinctUntilChanged())
      .subscribe(term => {
        this.addressAutocomplete(term);
      });
  }

  continueToStep3() {
    // Handle the change of loading text
    this.getQuoteMessage = 'Few more seconds for us to prepare your quote...';
    setTimeout(() => {
      this.getQuoteMessage = 'Your personalized quote is being formulated... \n This can take up to 60 seconds';
    }, 5000);

    // update lead with user clicked get quote
    this.leadService.clickedGetAQuote = 'true';
    const leadUpdate = this.leadService.updateLead(WebLeadType.WEB_LEAD_3, null, null, null,
      this.quotationService.campaign, this.quotationService.quotationRequest.medium);
    if (leadUpdate) {
      leadUpdate.subscribe(
        response => {
          this.leadService.updateLeadResponse = response;
        }, error => {
          this.quotationService.error = true;
        });
    }

    this.validationService.clearErrors();
    if (this.validationService.isStepTwoValid()) {
      this.loading = true;
      this.quotationService.generateQuotes().subscribe((quotationResults) => {
        // Assign quotations
        this.quotationService.quotationsForClient.quickQuote[0] = quotationResults['quickQuote'][0];
        this.quotationService.quotationsForClient.quickQuote[1] = quotationResults['quickQuote'][2];
        this.quotationService.quotationsForClient.quickQuote[2] = quotationResults['quickQuote'][1];
        this.loading = false;
        this.goToStep('Step 3');


        let recommendedQuote = null;
        if (this.quotationService.quotationsForClient && this.quotationService.quotationsForClient.quickQuote) {
          const quotes = this.quotationService.quotationsForClient.quickQuote;
          const preferredQuote = this.findElementQuote(quotes, 'quoteType', this.quotationService.quotationType);
          if (preferredQuote) {
            recommendedQuote = preferredQuote.quoteNo;
          }
        }
        const leadUpdate = this.leadService.updateLead(WebLeadType.WEB_LEAD_2, recommendedQuote, null, null,
          this.quotationService.campaign, this.quotationService.quotationRequest.medium);
        if (leadUpdate) {
          leadUpdate.subscribe(
            response => {
              this.leadService.updateLeadResponse = response;
            }, error => {
              this.quotationService.error = true;
            });
        }
      }, error1 => {
        if (this.quotationService.parseError(error1)) {
          return;
        }
        this.getContentError(error1['error'])
          .subscribe((response) => {
            this.quotationService.error = true;
            this.quotationService.errorMessage = response;
            this.quotationService.errorCode = error1['error'];
          }, contentError => {
            this.quotationService.error = true;
          });
      });
    }
  }

  getContentError(errorCode: string) {
    return this.contentComponent.customGetContent(environment.errorContentUrl + errorCode);
  }

  findElementQuote(arr, propName, propValue) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i][propName] === propValue && arr[i]['planType'] === 'CLASSIC_PLAN') {
        return arr[i];
      }
    }
  }

  changeVehicleUsage(vehicleUsage: VehicleUsage) {
    if (vehicleUsage === VehicleUsage.COMMERCIAL) {
      this.showCancelModal = true;
      this.quotationService.scrollToTop();

      this.quotationService.quotationRequest.vehicleUsage = null;
    } else {
      this.quotationService.quotationRequest.vehicleUsage = vehicleUsage;
    }
  }

  public isNotRepeat(): boolean {
    const registration = this.quotationService.quotationRequest.vehicleDetails.registrationNumber;
    const vinNUmber = this.quotationService.quotationRequest.vehicleDetails.vinNumber;

    if (registration != null &&
      registration !== undefined &&
      registration !== '') {
      return (registration !== this.numberPlateRetry);
    } else if (vinNUmber != null &&
      this.vinNumberRetry !== undefined &&
      vinNUmber !== '') {
      return (vinNUmber !== this.vinNumberRetry);
    }
  }

  public searchVehicleAgain() {
    this.quotationService.scrollToTop();

    this.validationService.errorMessages = [];
    if ((this.vinNumberRetry == null || this.vinNumberRetry === '') &&
      (this.numberPlateRetry == null || this.numberPlateRetry === '') && this.isNotRepeat()) {
      if (!this.validationService.errorMessages.some(s => s.includes(ErrorMessages.PLATE_OR_VIN))) {
        this.validationService.errorMessages.push(ErrorMessages.PLATE_OR_VIN);
      }
    } else {
      this.vehicleLoading = true;
      this.quotationService.reduceRetries();
      this.quotationService.quotationRequest.vehicleDetails.registrationNumber = this.numberPlateRetry;
      this.quotationService.quotationRequest.vehicleDetails.vinNumber = this.vinNumberRetry;
      this.quotationService.requestVehicleDetails().subscribe((response) => {
        this.vehicleLoading = false;

        // If searching for vehicle returns an error  code from the redirect list then direct to manual capture page
        if (response['serviceError'] && response['serviceError'][0] && response['serviceError'][0]['code']) {
          this.getContentError(response['serviceError'][0]['code'].toString()).subscribe((result) => {
            this.quotationService.errorMessage = result;
            this.quotationService.errorCode = response['serviceError'][0]['code'].toString();

            // Update the lead that manual capture had to take place
            if(localStorage.getItem('urlHasLeadReference') === 'true'){
              this.quotationService.quotationRequest.medium = 'MOBILE';
            }
            if (this.leadService.updateLead(WebLeadType.WEB_LEAD_3)) {
              this.leadService.updateLead(WebLeadType.WEB_LEAD_3, null, null,
                this.quotationService.errorCode + ':' + this.quotationService.errorMessage.replace(/\n/g, ''),
                this.quotationService.quotationRequest.campaign, this.quotationService.quotationRequest.medium)
                .subscribe((leadUpdateResult) => {
                }, error1 => {
                  this.quotationService.setFallbackError();
                });
            }

            if (this.quotationService.errorCode === '6') {
              this.quotationService.licenseFound = true;
            }

            this.goToStep('Step 2-alt');
          });
        } else {
          this.quotationService.quotationRequest.vehicleDetails = response['vehicleDetails'];
        }
      }, error1 => {
        // Check if timeout occurred
        if (this.quotationService.parseError(error1)) {
          return;
        }

        // Fetch the correct error content fragment
        this.getContentError(this.quotationService.errorCode)
          .subscribe((response) => {
            this.quotationService.getErrorList().subscribe((errorListString: string[]) => {

              this.quotationService.errorMessage = response;

              if (errorListString.toString().indexOf(this.quotationService.errorCode.toString()) !== -1 ||
                this.quotationService.errorCode === '99') {

                if (this.quotationService.errorCode.toString() === '6') {
                  this.quotationService.licenseFound = true;
                }
                // update lead with error
                if (this.leadService.updateLead(WebLeadType.WEB_LEAD_3)) {
                  this.leadService.updateLead(WebLeadType.WEB_LEAD_3, null, null,
                    this.quotationService.errorCode + ':' + this.quotationService.errorMessage.replace(/\n/g, ''),
                    this.quotationService.quotationRequest.campaign, this.quotationService.quotationRequest.medium)
                    .subscribe((leadUpdateResult) => {
                    }, leadUpdateError => {
                      this.quotationService.setFallbackError();
                    });
                }

                this.quotationService.quotationStep = QuotationStep.STEP_2_ALT;
                this.quotationService.error = false;
              } else {
                this.quotationService.error = true;
              }
            });
          }, contentError => {
            this.quotationService.setFallbackError();
          });
      });
    }
  }

  cancelSelection() {
    this.showCancelModal = false;
    this.quotationService.quotationRequest.vehicleUsage = VehicleUsage.SELECT_USAGE;
  }

  cancelQuote() {
    this.showCancelModal = false;
    this.quotationService.quotationStep = QuotationStep.LANDING;
    this.router.navigateByUrl('choose-insurance-quote');
  }

  detailsInvalid() {
    return this.loading || this.quotationService.quotationRequest.vehicleDetails == null;
  }

  public addressAutocomplete(phrase: string): void {
    if (phrase.length >= 4) {
      this.quotationService.addressRequest.address = phrase;
      this.quotationService.getAddressList().subscribe((addressList: Address[]) => {
        this.searched = true;
        this.addressList.next(addressList);
      }, error1 => {
        this.quotationService.error = true;
      });
    }
  }

  public selectAddress(address: Address) {
    if (!isNullOrUndefined(address)) {
      this.quotationService.quotationRequest.parkingAddress = address;
    }
    this.addressList.next([]);
  }

  inputChange(value: any) {
    this.searchTerm.next(value);
  }

  formatRegistration() {
    this.numberPlateRetry =
      this.numberPlateRetry.replace(' ', '').toUpperCase();
  }
}
